import { render, staticRenderFns } from "./profile-animation.vue?vue&type=template&id=38281725&scoped=true&"
import script from "./profile-animation.vue?vue&type=script&lang=js&"
export * from "./profile-animation.vue?vue&type=script&lang=js&"
import style0 from "./profile-animation.vue?vue&type=style&index=0&id=38281725&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38281725",
  null
  
)

export default component.exports